<template>
  <div>
    <div>
      <h1 style="color:blue">
        NFPA 10 Standard for Portable Fire Extinguishers 2018 Edition
      </h1>
      <h2>Chapter 7 Inspection, Maintenance, and Recharging</h2>
      <h5>
        7.1 *  General. <br />
        7.1.1 Responsibility.
      </h5>
      <p>
        The owner or designated agent or occupant of a property in which fire
        extinguishers are located shall be responsible for inspection,
        maintenance, and recharging. (See 7.1.2.)
      </p>

      <h5>7.1.2 Personnel.</h5>
      <h5>7.1.2.1 *</h5>
      <p>
        Persons performing maintenance and recharging of extinguishers shall be
        certified.
      </p>

      <h5>7.1.2.1.1</h5>
      <p>
        Persons training to become certified shall be permitted to perform
        maintenance and recharging of extinguishers under the direct supervision
        and in the immediate presence of a certified person.
      </p>

      <h5>7.1.2.1.2 *</h5>
      <p>
        Certification requires that a person pass a test administered by an
        organization acceptable to the AHJ.
      </p>

      <h5>7.1.2.1.3</h5>
      <p>
        The test shall, at a minimum, be based upon knowledge of the chapters
        and annexes of this standard.
      </p>

      <h5>7.1.2.1.4</h5>
      <p>
        The testing process shall permit persons to use the standard during the
        test.
      </p>

      <h5>7.1.2.1.5</h5>
      <p>
        Persons passing the test required in 7.1.2.1.2 shall be issued a
        document or a certificate.
      </p>

      <h5>7.1.2.1.6</h5>
      <p>
        The document or certificate shall be made available when requested by
        the authority having jurisdiction.
      </p>

      <h5>7.1.2.2</h5>
      <p>
        Persons performing maintenance and recharging of extinguishers shall be
        trained and shall have available the appropriate manufacturer’s
        servicing manual(s), the correct tools, recharge materials, lubricants,
        and manufacturer’s replacement parts or parts specifically listed for
        use in the fire extinguisher.
      </p>

      <h5>7.1.2.3 *</h5>
      <p>
        Persons performing inspections shall not be required to be certified.
      </p>

      <h5>7.1.3 Replacement While Servicing.</h5>
      <p>
        Fire extinguishers removed from service for maintenance or recharging
        shall be replaced by a fire extinguisher suitable for the type of hazard
        being protected and shall be of at least equal rating.
      </p>

      <h5>7.1.4 Tags or Labels.</h5>
      <h5>7.1.4.1</h5>
      <p>
        Tags or labels intended for recording inspections, maintenance, or
        recharging shall be affixed so as not to obstruct the fire extinguisher
        use, fire extinguisher classification, or manufacturer’s labels.
      </p>

      <h5>7.1.4.2</h5>
      <p>
        Labels indicating fire extinguisher use or classification, or both,
        shall be permitted to be placed on the front of the fire extinguisher.
      </p>

      <h5>7.2 Inspection.</h5>
      <h5>7.2.1 Inspection Frequency.</h5>
      <h5>7.2.1.1 *</h5>
      <p>
        Fire extinguishers shall be manually inspected when initially placed in
        service.
      </p>

      <h5>7.2.1.2 *</h5>
      <p>
        Fire extinguishers and Class D extinguishing agents shall be inspected
        either manually or by means of an electronic monitoring device/system at
        intervals not exceeding 31 days.
      </p>

      <h5>7.2.1.2.1</h5>
      <p>
        Fire extinguishers and Class D extinguishing agents shall be inspected
        at least once per calendar month.
      </p>

      <h5>7.2.1.3 *</h5>
      <p>
        Fire extinguishers and Class D extinguishing agents shall be manually
        inspected daily or weekly when conditions exist that indicate the need
        for more frequent inspections.
      </p>

      <h5>7.2.1.4</h5>
      <p>
        Extinguishers that are electronically monitored for location only, such
        as those monitored by means of a switch to indicate when the
        extinguisher is removed from its bracket or cabinet, shall be manually
        inspected in accordance with 7.2.2.
      </p>

      <h5>7.2.2 Inspection Procedures.</h5>
      <p>
        Periodic inspection or electronic monitoring of fire extinguishers shall
        include a check of at least the following items: 1 Location in
        designated place 2 Visibility of the extinguisher or means of indicating
        the extinguisher location 3 Access to the extinguisher 4 Pressure gauge
        reading or indicator in the operable range or position 5 Fullness
        determined by weighing or hefting 6 Condition of tires, wheels,
        carriage, hose, and nozzle for wheeled extinguishers 7 Indicator for
        nonrechargeable extinguishers using push-to-test pressure indicators
      </p>

      <h5>7.2.2.1</h5>
      <p>
        The owner or the owner’s agent shall determine the method of
        extinguisher inspection such as manual inspection, electronic
        monitoring, or any combination of the two.
      </p>

      <h5>7.2.2.2</h5>
      <p>
        Any method(s) of inspection other than manual inspection shall require
        the approval of the authority having jurisdiction.
      </p>

      <h5>7.2.2.3 *</h5>
      <p>
        In addition to 7.2.2, fire extinguishers shall be visually inspected in
        accordance with 7.2.2.4 if they are located where any of the following
        conditions exists: 1 High frequency of fires in the past 2 Severe
        hazards 3 Locations that make fire extinguishers susceptible to
        mechanical injury or physical damage 4 Exposure to abnormal temperatures
        or corrosive atmospheres
      </p>

      <h5>7.2.2.4</h5>
      <p>
        Where required by 7.2.2.3, the following inspection procedures shall be
        in addition to those addressed in 7.2.2: 1 Verify that operating
        instructions on nameplates are legible and face outward 2 Check for
        broken or missing safety seals and tamper indicators 3 Examine for
        obvious physical damage, corrosion, leakage, or clogged nozzle
      </p>

      <h5>
        7.2.2.5 Inspection Procedure for Containers of Class D Extinguishing
        Agent.
      </h5>
      <p>
        Periodic inspection of containers of Class D extinguishing agent used to
        protect Class D hazards shall include verification of at least the
        following: 1 Located in designated place 2 Visibility of the container
        or means of indicating the container location 3 Access to the container
        4 Lid is sealed 5 Fullness by hefting or weighing 6 No obvious physical
        damage to container
      </p>

      <h5>7.2.3 Corrective Action.</h5>
      <p>
        When an inspection of any fire extinguisher reveals a deficiency in any
        of the conditions in 7.2.2 or 7.2.2.4, immediate corrective action shall
        be taken.
      </p>

      <h5>7.2.3.1 Rechargeable Fire Extinguishers.</h5>
      <p>
        When an inspection of any rechargeable fire extinguisher reveals a
        deficiency in any of the conditions in 7.2.2(4), 7.2.2(5), 7.2.2(7),
        or 7.2.2.4(1) through 7.2.2.4(3), the extinguisher shall be subjected to
        applicable maintenance procedures.
      </p>

      <h5>7.2.3.2 Nonrechargeable Dry Chemical Fire Extinguisher.</h5>
      <p>
        When an inspection of any nonrechargeable dry chemical fire extinguisher
        reveals a deficiency in any of the conditions listed
        in 7.2.2(4), 7.2.2(5), 7.2.2(7), or 7.2.2.4(1) through 7.2.2.4(3), the
        extinguisher shall be removed from further use, discharged, and
        destroyed at the direction of the owner or returned to the manufacturer.
      </p>

      <h5>7.2.3.3 Nonrechargeable Halon Agent Fire Extinguisher.</h5>
      <p>
        When an inspection of any nonrechargeable fire extinguisher containing a
        halon agent reveals a deficiency in any of the conditions listed
        in 7.2.2(4), 7.2.2(5), 7.2.2(7), or 7.2.2.4(1) through 7.2.2.4(3), the
        extinguisher shall be removed from service, shall not be discharged, and
        shall be returned to the manufacturer, a fire equipment dealer, or a
        distributor to permit recovery of the halon.
      </p>

      <h5>7.2.4 Inspection Record Keeping.</h5>
      <h5>7.2.4.1 Manual Inspection Records.</h5>
      <h5>7.2.4.1.1</h5>
      <p>
        Where manual inspections are conducted, records for manual inspections
        shall be kept on a tag or label attached to the fire extinguisher, on an
        inspection checklist maintained on file, or by an electronic method.
      </p>

      <h5>7.2.4.1.2</h5>
      <p>
        Where manual inspections are conducted, the month and year the manual
        inspection was performed and the initials of the person performing the
        inspection shall be recorded.
      </p>

      <h5>7.2.4.1.3</h5>
      <p>
        Personnel making manual inspections shall keep records of all fire
        extinguishers inspected, including those found to require corrective
        action.
      </p>

      <h5>7.2.4.1.4</h5>
      <p>
        Records for manual inspection shall be kept to demonstrate that at least
        the last 12 monthly inspections have been performed.
      </p>

      <h5>7.2.4.2 Electronic Inspection Records.</h5>
      <h5>7.2.4.2.1</h5>
      <p>
        Where electronically monitored systems are employed for inspections,
        records shall be kept for fire extinguishers found to require corrective
        action.
      </p>

      <h5>7.2.4.2.2</h5>
      <p>
        Records for electronic monitoring shall be kept to demonstrate that at
        least the last 12 monthly inspections have been performed.
      </p>

      <h5>7.2.4.2.3</h5>
      <p>
        For electronically monitored fire extinguishers, where the extinguisher
        causes a signal at a control unit when a deficiency in any of the
        conditions listed in 7.2.2occurs, record keeping shall be provided in
        the form of an electronic event log at the control panel.
      </p>

      <h5>7.3 Extinguisher Maintenance.</h5>
      <h5>7.3.1 *  Maintenance Procedures.</h5>
      <p>
        Where required by another section of this standard, maintenance
        procedures shall include the procedures detailed in the manufacturer’s
        service manual and a thorough examination of the basic elements of the
        fire extinguisher, including the following: 1 Mechanical parts of all
        fire extinguishers 2 Extinguishing agent 3 Expelling means 4 Physical
        condition
      </p>

      <h5>7.3.1.1</h5>
      <p>
        Fire extinguishers shall be subjected to maintenance at intervals of not
        more than 1 year, at the time of hydrostatic test, or when specifically
        indicated by an inspection discrepancy or electronic notification.
      </p>

      <h5>7.3.2 Annual External Examination of All Extinguishers.</h5>
      <h5>7.3.2.1 Physical Condition.</h5>
      <p>
        An annual external visual examination of all fire extinguishers shall be
        made to detect obvious physical damage, corrosion, or nozzle blockage to
        verify that the operating instructions are present, legible, and facing
        forward, and that the HMIS information is present and legible, and to
        determine if a 6-year interval examination or hydrostatic test is due.
      </p>

      <h5>7.3.2.2 *  Seals or Tamper Indicators.</h5>
      <p>
        At the time of the maintenance, the tamper seal of a rechargeable fire
        extinguisher shall be removed by operating the pull pin or locking
        device.
      </p>

      <h5>7.3.2.2.1</h5>
      <p>
        After the applicable maintenance procedures are completed, a new listed
        tamper seal shall be installed.
      </p>

      <h5>7.3.2.2.2</h5>
      <p>
        Seals or tamper indicators on nonrechargeable-type extinguishers shall
        not be removed.
      </p>

      <h5>7.3.2.3 *  Boots, Foot Rings, and Attachments.</h5>
      <p>
        All removable extinguisher boots, foot rings, and attachments shall be
        removed to accommodate thorough annual cylinder examinations.
      </p>

      <h5>7.3.2.4</h5>
      <p>
        When subjected to temperatures at or above their listed rating,
        stored-pressure fire extinguishers that require a 12-year hydrostatic
        test shall be emptied and subjected to the applicable maintenance and
        recharge procedures on an annual basis.
      </p>

      <h5>7.3.2.5 Corrective Action.</h5>
      <p>
        When an external examination of any fire extinguisher reveals a
        deficiency, immediate corrective action shall be taken.
      </p>

      <h5>
        7.3.3 Annual Internal Examination of Certain Types of Extinguishers.
      </h5>
      <h5>7.3.3.1 *  Maintenance Intervals.</h5>
      <p>
        Fire extinguishers shall be internally examined at intervals not
        exceeding those specified in Table 7.3.3.1.
      </p>
    </div>
    <div>
      <b-table striped hover :items="items">
        <template #table-caption
          >*Dry chemical and dry powder in cartridge- or cylinder-operated
          extinguishers are examined annually. <br />†The extinguishing agent in
          liquid charge-type AFFF and FFFP extinguishers is replaced every 3
          years, and an internal examination (teardown) is normally conducted at
          that time.</template
        >
      </b-table>
    </div>
    <div>
      <h5> 7.3.3.2 Loaded Stream Charge. </h5>
Stored-pressure types of fire extinguishers containing a loaded stream agent shall be disassembled on an annual basis and subjected to complete maintenance.

<h5>7.3.3.2.1 </h5>
The loaded stream charge shall be permitted to be recovered and re-used, provided it is subjected to agent analysis in accordance with the extinguisher manufacturer’s instructions.

<h5>7.3.3.2.2 </h5>
When the internal maintenance procedures are performed during periodic recharging or hydrostatic testing, the 1-year requirement shall begin from that date.

<h5>7.3.3.3 *  Cartridge- or Cylinder-Operated Extinguishers.</h5>
The extinguishing agent of cartridge- or cylinder-operated extinguishers shall be internally examined annually.

<h5>7.3.3.4 Wetting Agent Extinguishers.</h5>
Wetting agent extinguishers shall be disassembled on an annual basis and subjected to complete maintenance.

<h5>7.3.3.5 Pump Tank Extinguishers.</h5>
Pump tank extinguishers shall be internally examined annually.

<h5>7.3.3.6 </h5>
Annual internal examination shall not be required for nonrechargeable fire extinguishers, carbon dioxide fire extinguishers, or stored-pressure fire extinguishers, except for those types specified in 7.3.3.2.

<h5>7.3.4 *  Annual Maintenance Record Keeping.</h5>
<h5>7.3.4.1 </h5>
Each fire extinguisher shall have a tag or label securely attached that indicates that maintenance was performed.

<h5>7.3.4.1.1 </h5>
The tag or label, as a minimum, shall identify the following:

1  Month and year maintenance was performed

2  Person performing the work

3  Name of the agency performing the work


<h5>7.3.4.2 </h5>
Each extinguisher that has undergone maintenance that includes internal examination, except extinguishers identified in 7.3.3.3 and 7.3.3.5 shall have a verification-of-service collar located around the neck of the container.

<h5>7.3.5 Corrective Action.</h5>
When maintenance of any fire extinguisher reveals a deficiency, immediate corrective action shall be taken.

<h5> 7.3.6 Six-Year Internal Examination of Certain Types of Extinguishers.</h5>
Every 6 years, stored-pressure fire extinguishers that require a 12-year hydrostatic test shall be emptied and subjected to the applicable internal and external examination procedures as detailed in the manufacturer’s service manual and this standard.

<h5> 7.3.6.1 </h5>
When the applicable maintenance procedures are performed during periodic recharging or hydrostatic testing, the 6-year requirement shall begin from that date.

<h5> 7.3.6.2 * </h5>
The removal of agent from halon agent fire extinguishers shall only be done using a listed halon closed recovery system.

<h5> 7.3.6.3 </h5>
Nonrechargeable fire extinguishers shall not be required to have a 6-year internal examination and shall not be hydrostatically tested but shall be removed from service at a maximum interval of 12 years from the date of manufacture.

<h5> 7.3.6.3.1 </h5>
Nonrechargeable halon agent fire extinguishers shall be disposed of in accordance with 7.2.3.3.

<h5> 7.3.6.4 Corrective Action.</h5>
When an internal examination of any fire extinguisher reveals a deficiency, immediate corrective action shall be taken.

<h5> 7.3.6.5 *  Six-Year Internal Examination Label.</h5>
Fire extinguishers that pass the applicable 6-year requirement of 7.3.6 shall have the maintenance information recorded on a durable weatherproof label that is a minimum of 2 in. × 31∕ 2 in. (51 mm × 89 mm).

<h5> 7.3.6.5.1 </h5>
The new label shall be affixed to the shell by a heatless process, and any previous 6-year internal examination labels shall be removed.

<h5> 7.3.6.5.2 </h5>
These labels shall be of the self-destructive type when their removal from a fire extinguisher is attempted.

<h5> 7.3.6.5.3 </h5>
The 6-year internal examination label shall, as a minimum, identify the following:

1  Month and year the 6-year internal examination was performed

2  Person performing the work

3  Name of the agency performing the work


<h5> 7.4 *  Carbon Dioxide Hose Assembly Conductivity Test.</h5>
A conductivity test shall be conducted annually on all carbon dioxide hose assemblies.

<h5> 7.4.1 </h5>
Carbon dioxide hose assemblies that fail the conductivity test shall be replaced.

<h5> 7.4.2 Record Keeping for Conductivity Testing of Carbon Dioxide Hose Assemblies.</h5>
<h5> 7.4.2.1 </h5>
Carbon dioxide hose assemblies that pass a conductivity test shall have the test information recorded on a durable weatherproof label that is a minimum of 1∕ 2in. × 3 in. (13 mm × 76 mm).

<h5> 7.4.2.2 </h5>
The label shall be affixed to the hose by means of a heatless process.

<h5> 7.4.2.3 </h5>
The label shall include the following information:

1  Month and year the test was performed, indicated by perforation, such as is done by a hand punch

2  Name or initials of person performing the test and the name of the agency performing the test


<h5> 7.5 Hose Station Maintenance.</h5>
Where hose stations are installed to comply with 6.2.1.4, they shall be maintained in accordance with NFPA 1962.

<h5> 7.6 Electronic Monitoring System Maintenance.</h5>
<h5> 7.6.1 Electronic Monitoring.</h5>
The components of the monitoring device/system shall be tested and maintained annually in accordance with the manufacturer’s listed maintenance manual, with the following items included as a minimum:

1  Power supply inspection/battery change

2  Obstruction sensor inspection

3  Location sensor inspection

4  Pressure indication inspection

5  Connection continuity inspection (See 7.6.1.1 and 7.6.1.2.)


<h5> 7.6.1.1 </h5>
One hundred percent of all units shall be tested upon initial installation or reacceptance with verification of receipt of signal at the control panel or a local alarm.

<h5> 7.6.1.2 </h5>
Twenty percent of units shall be tested annually on a rotating basis so that all units are tested within a 5-year period.

<h5> 7.6.2 </h5>
When used in conjunction with fire alarm systems, fire extinguisher electronic monitoring devices shall be inspected and maintained in accordance with NFPA 72 and 7.6.1.

<h5> 7.6.3 Corrective Action.</h5>
When maintenance of any monitoring system reveals a deficiency, immediate corrective action shall be taken.

<h5> 7.7 Maintenance of Wheeled Extinguisher Hoses and Regulators.</h5>
<h5> 7.7.1 Wheeled Unit Hoses.</h5>
Discharge hoses on wheeled-type fire extinguishers shall be completely uncoiled and examined for damage annually.

<h5> 7.7.1.1 * </h5>
Discharge hoses on wheeled extinguishers shall be coiled in a manner to prevent kinks and to allow rapid deployment in accordance with the manufacturer’s instructions.

<h5> 7.7.2 Pressure Regulators.</h5>
Pressure regulators provided with wheeled-type fire extinguishers shall be tested annually for outlet static pressure and flow rate in accordance with the manufacturer’s instructions.

<h5> 7.7.3 Corrective Action.</h5>
When maintenance of any fire extinguisher hose or pressure regulator reveals a deficiency, immediate corrective action shall be taken.

<h5> 7.8 Extinguisher Recharging and Extinguishing Agents.</h5>
<h5> 7.8.1 *  General.</h5>
<h5> 7.8.1.1 </h5>
All rechargeable-type fire extinguishers shall be recharged after any use or when the need is indicated by an inspection or servicing.

<h5> 7.8.1.2 * </h5>
When recharging is performed, the manufacturer’s service manual shall be followed. (For recharge agents, see 7.8.3.)

<h5> 7.8.1.3 * </h5>
The amount of recharge agent shall be verified by weighing.

<h5> 7.8.1.3.1 </h5>
For those fire extinguishers that do not have the gross weight marked on the nameplate or valve, a permanent label that indicates the gross weight shall be affixed to the cylinder.

<h5> 7.8.1.3.2 </h5>
The added label containing the gross weight shall be a durable material of a pressure-sensitive, self-destruct type. (For stored-pressure water-type extinguishers, see 7.8.3.10.)

<h5> 7.8.1.3.3 </h5>
Pump tank water and pump tank calcium chloride–based antifreeze types shall not be required to have weight marked.

<h5> 7.8.1.3.4 * </h5>
After recharging, a leak test shall be performed on stored-pressure and self-expelling types of fire extinguishers.

<h5> 7.8.1.3.5 </h5>
In no case shall an extinguisher be recharged without hydrostatic testing if it is beyond its specified hydrostatic test date.

<h5> 7.8.2 Extinguisher Recharging Frequency for Certain Types of Extinguishers.</h5>
<h5> 7.8.2.1 Pump Tank.</h5>
Every 12 months, pump tank water and pump tank calcium chloride–based antifreeze types of fire extinguishers shall be recharged with new chemicals or water as applicable.

<h5> 7.8.2.2 Wetting Agent.</h5>
The agent in stored-pressure wetting agent fire extinguishers shall be replaced annually.

<h5> 7.8.2.2.1 </h5>
Only the agent specified on the nameplate shall be used for recharging.

<h5> 7.8.2.2.2 </h5>
The use of water or any other additives shall be prohibited.

<h5> 7.8.2.3 AFFF and FFFP.</h5>
<h5> 7.8.2.3.1 </h5>
The premixed agent in liquid charge–type AFFF and FFFP fire extinguishers shall be replaced at least once every 3 years.

<h5> 7.8.2.3.2 </h5>
Only the foam agent specified on the extinguisher nameplate shall be used for recharge.

<h5> 7.8.2.3.3 </h5>
The agent in nonpressurized AFFF and FFFP fire extinguishers that is subjected to agent analysis in accordance with manufacturer’s instructions shall not be required to comply with 7.8.2.3.1.

<h5> 7.8.3 *  Recharge Agents.</h5>
<h5> 7.8.3.1 </h5>
Only those agents specified on the nameplate or agents proven to have equal chemical composition, physical characteristics, and fire-extinguishing capabilities shall be used.

<h5> 7.8.3.1.1 </h5>
Agents listed specifically for use with that fire extinguisher shall be considered to meet these requirements.

<h5> 7.8.3.2 *  Mixing of Dry Chemicals.</h5>
Multipurpose dry chemicals shall not be mixed with alkaline-based dry chemicals.

<h5> 7.8.3.3 Topping Off.</h5>
<h5> 7.8.3.3.1 </h5>
The remaining dry chemical in a discharged fire extinguisher shall be permitted to be re-used, provided that it is thoroughly checked for the proper type, contamination, and condition.

<h5> 7.8.3.3.2 </h5>
Dry chemical found to be of the wrong type or contaminated shall not be re-used.

<h5> 7.8.3.4 Dry Chemical Agent Re-Use.</h5>
<h5> 7.8.3.4.1 </h5>
The dry chemical agent shall be permitted to be re-used, provided a closed recovery system is used and the agent is stored in a sealed container to prevent contamination.

<h5> 7.8.3.4.2 </h5>
Prior to re-use, the dry chemical shall be thoroughly checked for the proper type, contamination, and condition.

<h5> 7.8.3.4.3 </h5>
Where doubt exists with respect to the type, contamination, or condition of the dry chemical, the dry chemical shall be discarded.

<h5> 7.8.3.4.4 Dry Chemical Closed Recovery System.</h5>
<h5> 7.8.3.4.4.1 </h5>
The system shall be constructed in a manner that does not introduce foreign material into the agent being recovered.

<h5> 7.8.3.4.4.2 </h5>
The system shall have a means for visual inspection of the recovered agent for contaminants.

<h5> 7.8.3.5 Dry Powder.</h5>
<h5> 7.8.3.5.1 </h5>
Pails or drums containing dry powder agents for scoop or shovel application for use on metal fires shall be kept full and sealed with the lid provided with the container.

<h5> 7.8.3.5.2 </h5>
The dry powder shall be replaced if found damp. (See A.‍7.8.3.)

<h5> 7.8.3.6 *  Removal of Moisture.</h5>
For all non-water types of fire extinguishers, any moisture shall be removed before recharging.

<h5> 7.8.3.7 *  Halogenated Agent.</h5>
Halogenated agent fire extinguishers shall be charged with only the type and weight of agent specified on the nameplate.

<h5> 7.8.3.8 Halogenated Agent Re-Use.</h5>
<h5> 7.8.3.8.1 </h5>
The removal of Halon 1211 from fire extinguishers shall be done using only a listed halon closed recovery system.

<h5> 7.8.3.8.2 </h5>
The removal of agent from other halogenated agent fire extinguishers shall be done using only a closed recovery system.

<h5> 7.8.3.8.3 </h5>
The fire extinguisher shall be examined internally for contamination or corrosion or both.

<h5> 7.8.3.8.4 </h5>
The halogenated agent retained in the system recovery cylinder shall be re-used only if no evidence of internal contamination is observed in the fire extinguisher cylinder.

<h5> 7.8.3.8.5 </h5>
Halogenated agent removed from fire extinguishers that exhibits evidence of internal contamination or corrosion shall be processed in accordance with the fire extinguisher manufacturer’s instructions.

<h5> 7.8.3.9 *  Carbon Dioxide.</h5>
<h5> 7.8.3.9.1 </h5>
The vapor phase of carbon dioxide shall be not less than 99.5 percent carbon dioxide.

<h5> 7.8.3.9.2 </h5>
The water content shall be not more than 60 parts per million (ppm) by weight at −52°F (−47°C) dew point.

<h5> 7.8.3.9.3 </h5>
Oil content shall not exceed 10 ppm by weight.

<h5> 7.8.3.10 *  Water Types.</h5>
The amount of liquid agent shall be determined by using one of the following:

1  Exact measurement by weight

2  Exact measurement by volume

3  Anti-overfill tube, if provided

4  Fill mark on fire extinguisher shell, if provided


<h5> 7.8.3.10.1 </h5>
Only the agent specified on the extinguisher nameplate shall be used for recharge.

<h5> 7.8.3.10.2 </h5>
Only additives identified on the original nameplate shall be permitted to be added to water-type extinguishers.

<h5> 7.8.3.11 Wet Chemical and Water Mist Agent Re-Use.</h5>
<h5> 7.8.3.11.1 </h5>
Wet chemical and water mist agents shall not be re-used.

<h5> 7.8.3.11.2 </h5>
If a wet chemical or water mist extinguisher is partially discharged, all remaining wet chemical or water mist shall be discarded.

<h5> 7.8.3.11.3 </h5>
Wet chemical or water mist agent shall be discarded and replaced at the hydrostatic test interval.

<h5> 7.8.3.11.3.1 </h5>
Only the agent specified on the extinguisher nameplate shall be used for recharge.

<h5> 7.8.4 Recharging Expellant Gas for Stored-Pressure Fire Extinguishers.</h5>
<h5> 7.8.4.1 </h5>
Only standard industrial-grade nitrogen with a maximum dew point of −60°F (−51°C), in accordance with CGA G-10.1, Commodity Specification for Nitrogen, shall be used to pressurize stored-pressure dry chemical and halogenated-type fire extinguishers that use nitrogen as a propellant.

<h5> 7.8.4.2 </h5>
Halogenated-type fire extinguishers that require argon shall be pressurized with argon with a dew point of −65°F (−54°C) or lower.

<h5> 7.8.4.3 </h5>
Compressed air shall be permitted to be used from special compressor systems capable of delivering air with a dew point of −60°F (−51°C) or lower. (See Annex J.)

<h5> 7.8.4.3.1 </h5>
The special compressor system shall be equipped with an automatic monitoring and alarm system to ensure that the dew point remains at or below −60°F (−51°C) at all times.

<h5> 7.8.4.3.2 </h5>
Compressed air through moisture traps shall not be used for pressurizing even though so stated in the instructions on older fire extinguishers.

<h5> 7.8.4.3.3 </h5>
Compressed air without moisture removal devices shall be permitted for pressurizing water extinguishers and foam hand extinguishers only.

<h5> 7.8.4.4 * </h5>
Class D wet chemical, water mist, and halogenated agent fire extinguishers shall be repressurized only with the type of expellant gas referred to on the fire extinguisher label.

<h5> 7.8.4.5 </h5>
A rechargeable stored-pressure-type fire extinguisher shall be pressurized only to the charging pressure specified on the fire extinguisher nameplate.

<h5> 7.8.4.5.1 </h5>
The manufacturer’s pressurizing adapter shall be connected to the valve assembly before the fire extinguisher is pressurized.

<h5> 7.8.4.5.2 </h5>
A regulated source of pressure, set no higher than 25 psi (172 kPa) above the operating (service) pressure, shall be used to pressurize fire extinguishers.

<h5> 7.8.4.5.3 </h5>
The gauge used to set the regulated source of pressure shall be calibrated at least annually.

<h5> 7.8.4.6 * </h5>
An unregulated source of pressure, such as a nitrogen cylinder without a pressure regulator, shall not be used.

<h5> 7.8.4.7 * </h5>
A fire extinguisher shall not be left connected to the regulator of a high-pressure source for an extended period of time.

<h5> 7.8.4.8 Recharge Record Keeping.</h5>
<h5> 7.8.4.8.1 </h5>
Each fire extinguisher shall have a tag or label attached that indicates the month and year recharging was performed, identifies the person performing the service, and identifies the name of the agency performing the work.

<h5> 7.8.4.8.2 </h5>
Each extinguisher that has been recharged shall have a verification-of-service collar located around the neck of the container, except as identified in 7.11.4.

<h5> 7.9 *  Pressure Gauges.</h5>
<h5> 7.9.1 </h5>
Replacement pressure gauges shall have the correct indicated charging (service) pressure.

<h5> 7.9.2 </h5>
Replacement pressure gauges shall be marked for use with the agent in the fire extinguisher.

<h5> 7.9.3 </h5>
Replacement pressure gauges shall be compatible with the fire extinguisher valve body material.

<h5> 7.10 Prohibition on Uses of Extinguishers and Conversion of Fire Extinguisher Types.</h5>
<h5> 7.10.1 </h5>
Fire extinguishers shall not be used for any purpose other than that of a fire extinguisher.

<h5> 7.10.2 </h5>
Fire extinguishers shall not be converted from one type to another, modified, or altered.

<h5> 7.10.3 </h5>
Fire extinguishers shall not be converted for the use of a different type of extinguishing agent.

<h5> 7.11 *  Maintenance and Recharge Service Collar.</h5>
Each extinguisher that has undergone maintenance that included internal examination or that has been recharged requiring the removal of the valve assembly shall have a verification-of-service collar located around the neck of the container.

<h5> 7.11.1 </h5>
The collar shall be a single circular piece of uninterrupted material forming a hole of a size that does not permit the collar assembly to move over the neck of the container unless the valve is completely removed.

<h5> 7.11.2 </h5>
The collar shall not interfere with the operation of the fire extinguisher.

<h5> 7.11.3 </h5>
The verification of service collar shall, as a minimum, identify the following:

1  Month and year the recharging or internal examination was performed

2  Name of the agency performing the work


<h5> 7.11.4 Service Collar Exemptions.</h5>
<h5> 7.11.4.1 </h5>
New extinguishers requiring an initial charge in the field (such as pressurized water, AFFF, FFFP, or wet chemical extinguishers) shall not be required to have a verification-of-service collar installed.

<h5> 7.11.4.2 </h5>
Liquefied gas, halogenated agent, and carbon dioxide extinguishers that have been recharged without valve removal shall not be required to have a verification-of-service collar installed following recharge.

<h5> 7.11.4.3 </h5>
Cartridge- and cylinder-operated extinguishers shall not be required to have a verification-of-service collar installed.

<h5> 7.12 *  Weight Scales.</h5>
Weight scales used for the maintenance and recharge of fire extinguishers shall have the reading increments and the accuracy necessary to verify the charge weights required in the service manuals and on the nameplates.

    </div>
  </div>
</template>

<script>
export default {
  name: 'FE_3_Code_NFPA2018',
  data() {
    return {
      items: [
        {
          Extinguisher_Type: "Stored-pressure loaded stream and antifreeze",
          Internal_Examination_Interval_years: "1",
        },
        {
          Extinguisher_Type:
            "Pump tank water and pump tank, calcium chloride based",
          Internal_Examination_Interval_years: "1",
        },
        {
          Extinguisher_Type:
            "Dry chemical, cartridge- and cylinder-operated, with mild steel shells",
          Internal_Examination_Interval_years: "1*",
        },
        {
          Extinguisher_Type:
            "Dry powder, cartridge- and cylinder-operated, with mild steel shells",
          Internal_Examination_Interval_years: "1*",
        },
        {
          Extinguisher_Type: "Wetting agent",
          Internal_Examination_Interval_years: "1",
        },
        {
          Extinguisher_Type: "Stored-pressure water",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type: "AFFF (aqueous film-forming foam)",
          Internal_Examination_Interval_years: "3†",
        },
        {
          Extinguisher_Type: "FFFP (film-forming fluoroprotein foam)",
          Internal_Examination_Interval_years: "3†",
        },
        {
          Extinguisher_Type:
            "Stored-pressure dry chemical, with stainless steel shells",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Carbon dioxide",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type: "Wet chemical",
          Internal_Examination_Interval_years: "5",
        },
        {
          Extinguisher_Type:
            "Dry chemical stored-pressure, with mild steel shells, brazed brass shells, and aluminum shells",
          Internal_Examination_Interval_years: "6",
        },
        {
          Extinguisher_Type: "Halogenated agents",
          Internal_Examination_Interval_years: "6",
        },
        {
          Extinguisher_Type:
            "Dry powder, stored-pressure, with mild steel shells",
          Internal_Examination_Interval_years: "6",
        },
      ],
    };
  },
};
</script>

<style>
table,
th,
td {
  border: 1px solid black;
}
</style>
